import { PropsWithChildren, ReactNode } from "react";

import { Heading } from "@/ui/cva/Heading";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogOverlay,
  DialogPortal,
  DialogTitle,
} from "@radix-ui/react-dialog";

type ProProjectDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description?: string;
  footer: ReactNode;
};

/**
 * WHO-5959 6b. One dialog shell for create, rename, delete and the purchase
 * picker. Full width below `sm` (375px fits with a 16px gutter), capped above.
 */
export const ProProjectDialog = ({
  open,
  onOpenChange,
  title,
  description,
  footer,
  children,
}: PropsWithChildren<ProProjectDialogProps>) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogPortal>
        <DialogOverlay className="fixed inset-0 z-[1000] bg-black/40" />
        <DialogContent className="fixed left-1/2 top-1/2 z-[1001] flex max-h-[90vh] w-[calc(100%-2rem)] max-w-lg -translate-x-1/2 -translate-y-1/2 flex-col space-y-4 rounded-xl bg-white p-6">
          <DialogTitle asChild>
            <Heading as="h2" size="h4">
              {title}
            </Heading>
          </DialogTitle>
          {description ? (
            <DialogDescription className="font-body text-base text-grey-700">
              {description}
            </DialogDescription>
          ) : (
            <DialogDescription className="sr-only">{title}</DialogDescription>
          )}
          <div className="min-h-0 flex-1 overflow-y-auto">{children}</div>
          <div className="flex flex-wrap justify-end gap-3">{footer}</div>
        </DialogContent>
      </DialogPortal>
    </Dialog>
  );
};
